import React, { memo, useCallback, useState } from "react";
import "./DoctorsMemo.css";
import {
  MultiUploadDialog,
  UploadData,
} from "Components/SharedComponents/MultiUpload";
import { Txt, Div, Img } from "Components/GenericView";
import { c4A4A4A } from "Constants";

interface DoctorsMemoProps {
  // care owner id
  coId: string;

  /**
   * Compact design for list view
   */
  compact?: boolean;

  // can be s3:// urls
  // files?: string[];

  // https url or blob urls
  displayUrls?: string[];

  // Doctor's memo available
  memoAvailable?: boolean;

  onUploadSuccess: (files: UploadData[]) => void;
  onDelete: (index: number) => void;
  onNotAvailable: () => void;

  /**
   * Render readonly state
   */
  readOnly?: boolean;

  mt?: number;
  mb?: number;
  ml?: number;
}

const DoctorsMemo: React.FC<DoctorsMemoProps> = (props) => {
  const {
    coId,
    displayUrls,
    memoAvailable,
    onUploadSuccess,
    onDelete,
    onNotAvailable,
    mt,
    mb,
    ml,
    readOnly,
    compact,
  } = props;

  const [uploadDialogOpen, showUploadDialog] = useState(false);
  const length = displayUrls?.length || 0;

  const _showDialog = useCallback(
    (show: boolean) => () => showUploadDialog(show),
    []
  );
  const _onDeleteIdx = useCallback((idx: number) => () => onDelete(idx), [
    onDelete,
  ]);

  const _onUploadSuccess = useCallback(
    (files: UploadData[]) => {
      showUploadDialog(false);
      onUploadSuccess(files);
    },
    [onUploadSuccess]
  );

  const clsName = compact ? "v" : "h center";

  return (
    <Div mt={mt} ml={ml} mb={mb}>
      <div
        className={
          memoAvailable === false
            ? `${clsName} half-opacity disable-events`
            : clsName
        }
      >
        <Txt
          className={!compact ? "no-shrink" : ""}
          fs={12}
          color={c4A4A4A}
          minW={132}
          maxW={readOnly ? 100 : 208}
          mb={compact ? 10 : 0}
        >
          {compact || readOnly
            ? "Doctor’s memo or prescriptions."
            : "Please provide photo(s) of doctor’s memo or prescriptions."}
        </Txt>
        <div className="flex w">
          {displayUrls?.map((url: string, index: number) => (
            <div className="flex" key={index}>
              <Img className="dm-medBg-img coi-mb-memo" src={url} />

              {!readOnly && (
                <div
                  className="dm-medBg-img-cross"
                  onClick={_onDeleteIdx(index)}
                >
                  x
                </div>
              )}

              <Div width={readOnly ? 12 : 0} />
            </div>
          ))}
          {!readOnly && (
            <div className="dm-medBg-img-add" onClick={_showDialog(true)}>
              <span>+</span>
            </div>
          )}

          {uploadDialogOpen && (
            <MultiUploadDialog
              coId={coId}
              type="doctor_memo"
              onClose={_showDialog(false)}
              onUploadSuccess={_onUploadSuccess}
            />
          )}
        </div>
      </div>

      {!length && (
        <div
          className={
            "h dm-cpf-checkbox as-fs mr-6 mt-0  " +
            (memoAvailable === false ? "selected " : "") +
            (readOnly ? "disable-events" : "")
          }
        >
          <div className="flex mt-1" onClick={onNotAvailable}>
            <span className="dm-grey mr-1">Not available</span>
            <i />
          </div>
        </div>
      )}
    </Div>
  );
};

export default memo(DoctorsMemo);
